import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WorkflowIdPage.Toolbar.WorkflowVersionHistoryPromotion', {
    longText: 'Control the changes with workflow version history',
    shortText: 'Version history',
    tryIt: 'TRY IT FOR FREE',
});
